'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showModal = showModal;
exports.hide = hide;

var _constants = require('redux/constants');

/**
 * action для модального окна
 * @param nextState объект
 */
function showModal(nextState) {
    return {
        type: _constants.ModalConstants.MODAL_SHOW,
        state: nextState
    };
}

function hide() {
    return {
        type: _constants.ModalConstants.MODAL_HIDE
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/modal.js
// module id = 26
// module chunks = 0